import * as slideDeckActions from "./slide_decks";
import { AJAX, makeAjaxAction } from "../../shared/make_ajax_action";

export { AJAX };

export const dataRequestAjaxAction = function (state, triggeringAction) {
  const path = state.router.basename + state.router.pathname + ".json";
  const postData = {
    selected_year: state.main.filters.year.selectedValue.value,
    selected_cities: state.main.filters.cities.selectedValues.map(c => c.value),
    search_object_id: state.main.dataHubSearchObject.id
  };

  if (state.main.filters.country.selectedValue) {
    postData.selected_country = state.main.filters.country.selectedValue.value;
  }

  const extraActionProps =  {
    triggeringType: triggeringAction.type,
    sectionChanged: triggeringAction.sectionChanged,
    sectionSlug: triggeringAction.sectionSlug,
    tabSlug: triggeringAction.tabSlug,
    tabChanged: triggeringAction.tabChanged
  };

  return makeAjaxAction(path, { filter_data: postData }, extraActionProps);
};

export const slideDeckRequestAjaxAction = function (state, triggeringAction) {
  let path, httpMethod;
  const postData = {};

  if (triggeringAction.type === slideDeckActions.CHART_SLIDE_DECK_BUTTON_CLICKED) {
    path = "/slide_decks";
    httpMethod = "GET";
  } else if (triggeringAction.type === slideDeckActions.SUBMIT_SLIDE_DECK_BUTTON_CLICKED) {
    path = "/slide_decks/add_slide";
    postData.slide_deck_id = state.main.slideDecks.selectedOptionValue;
    postData.chart_svg = state.main.slideDecks.chartSvg;
    postData.name = state.main.slideDecks.textValue;
    postData.title = state.main.slideDecks.title;
    httpMethod = "POST";
  } else {
    throw "Triggering Action type not handled";
  }

  const extraActionProps =  {
    triggeringType: triggeringAction.type
  };

  return makeAjaxAction(path, { slide: postData }, extraActionProps, httpMethod);
};
